import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const SalesChartSummary = ({ dataset }) => {
  if (!dataset || !dataset.labels || !dataset.datasets) {
    return <p>No chart data available.</p>;
  }

  // Ensure all values in data arrays are numbers
  const cleanedData = {
    labels: dataset.labels,
    datasets: dataset.datasets.map((ds) => ({
      ...ds,
      data: ds.data.map((val) => Number(val)),
    })),
  };

  // To truly remove ALL horizontal grid lines including baseline,
  // use drawOnChartArea: false, and borderWidth: 0 for axis lines
  // Force bar colors to blue: main bar is #1976d2, the second (if any) is #629FF4, else default to #1976d2
  const getBarColors = (datasets) => {
    return datasets.map((ds, idx) => ({
      ...ds,
      backgroundColor: idx === 0 ? "#1976d2" : "#629FF4",
      borderColor: idx === 0 ? "#1976d2" : "#629FF4",
    }));
  };

  // Override backgroundColor and borderColor before passing to Bar
  const cleanedAndColoredData = {
    ...cleanedData,
    datasets: getBarColors(cleanedData.datasets),
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: "#222222",
          generateLabels: (chart) => {
            const original = ChartJS.defaults.plugins.legend.labels.generateLabels;
            return original(chart).map((label, idx) => ({
              ...label,
              fillStyle: idx === 0 ? "#1976d2" : "#629FF4",
              color: "#222222",
            }));
          },
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
          color: "#222222",
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
      },
      x: {
        ticks: {
          color: "#222222",
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
      },
    },
  };

  return (
    <div className="w-full">
      <Bar data={cleanedAndColoredData} options={options} />
    </div>
  );
};

export default SalesChartSummary;
